import React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Card from '../Card/Card.jsx'
import { getCourses } from '../../redux/actions/actions.js'


function Cards() {

    const courses = useSelector((state) => state.courses);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCourses(10, 0));
    }, [dispatch]);

    console.log('useselector', courses);

    return (
            <div className="row">
                {
                    courses
                        ? courses.map(course => (
                            <div className="col-12 col-sm-6 col-lg-3 mb-1" key={course.id}>
                                <Card
                                    title={course.title}
                                    imageSource={course.image}
                                    level={course.level}
                                    program={course.program}
                                    price={course.price}
                                    description={course.description}
                                    courseId={course.id}
                                />
                            </div>
                        ))
                        : <div><h3>Cargando cursos...</h3></div>
                }
            </div>
    )
}

export default Cards